// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__history-submission[data-v-f36aa5e8]{max-width:910px}", ""]);
// Exports
module.exports = exports;
